import { View, Model } from "backbone";
import template from 'dashboard/connections/connection-action-view.ejs'
import DashboardTable from 'dashboard/BaseDashboardTableView.js';
import ConnectionDashboardController from 'ConnectionDashboardController'; 
import RestService from 'RestService';
import constants    from 'Constants';
import NotificationService from 'NotificationService.js';
import Spinner from 'spin/spin';
import ActionService from 'dashboard/connections/action-type/ActionService';
import util from 'util/Util';
import eventBus from 'EventBus';
import listService from 'ListService';
import restMessages from 'RestMessages';

class ConnectionActionView extends View {

    initialize(opts) {

        this.template = template;
        this.connectionService = opts.connectionService;
        this.actionService = new ActionService ({model:this.model});
        this.tableId = "#actionsList";
       
        this.events = {
            "click button[name=addAction]": "newAction",
            "click button[name=removeAction]": "deleteAction",
            "click .editActionBttn": "editAction"
        };

        var pageWidth = $("#connectionActions").parent().width() - 100;

        this.model.set(
            {
                actionsModel: {
                    colModel: [
                        {
                            name: 'id',
                            index: 'id',
                            editable: false,
                            hidden:true
                        },
                        {
                            name: 'owner',
                            index: 'owner',
                            editable: false,
                            hidden:true
                        },
                        {
                            name: 'name',
                            index: 'name',
                            width: (pageWidth * (80 / 100)),
                            editable: true
                        },
                        {
                            name: 'active',
                            index: 'active',
                            editable: true,
                            edittype: 'checkbox',
                            editoptions: { value: "true:false" },
                            width: (pageWidth * (10 / 100)),
                            align: "center",
                            formatter: "checkbox",
                            formatoptions: { disabled: false }
                        },
                        {
                            name: 'edit',
                            index: 'edit',
                            editable: false,
                            width: (pageWidth * (10 / 100)),
                            align: "center",
                            formatter: function (cellvalue, options, rowobject) {
                                return '<button type="button" class="editActionBttn">Edit</button>';
                            }
                        }
                    ],
                    colNames: ['id','Owner', 'Action','Active',' ']
                }
            }, {silent: true});

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    saveAction(actionId, name, isActive){

        const connectionId = this.model.get('connectionId');

        RestService.getParametersByActionIdAndConnectionId(actionId,
            connectionId,
            constants.SETTINGS_CONNECTIONS_FORM_ID,
            constants.SETTINGS_CONNECTIONS_PURPOSE, true).then((actionResponse) => {

                let permissionsXML = actionResponse.general.PermissionsXML;

                if(permissionsXML){
                    let permissions = actionResponse.general.PermissionsXML.Permissions.User;
                    if (!Array.isArray(permissions)) {
                        permissions = [permissions];
                    }

                    permissionsXML = this.actionService.formatPermissionsForResponse(permissions);
                }

                const connectionDetails = actionResponse.details;
                connectionDetails.Action["_active"] = isActive;
                connectionDetails.Action["_name"] = name;

                let updateParameters = {
                    connectionId: this.model.get('connectionId'),
                    actionId: actionId,
                    name: name,
                    isActive: isActive,
                    type: actionResponse.general.Type,
                    actionXML:  this.actionService.convertToXMLAndCompress(connectionDetails),
                    permissionsXML: permissionsXML
                };
        
                RestService.updateAction(updateParameters).then((data) => {
                    console.log('updated Action');
                    console.log(data);
                }).catch((err) => {
                    console.log('Error on update');
                    console.log('This is the error', err);
                })
            });
        
        
    }

    newAction(){
        const connectionId = this.model.get("connectionId");
        const connectionType = this.model.get("connectionType");
        const actionXML = ConnectionDashboardController.getActionXMLTemplate(connectionId, connectionType);

        //PF-8827 Disable add action button until service has responded
        $("button[name=addAction]").prop('disabled', true);

        RestService.addAction(connectionId, actionXML.type, actionXML.xml).then((data)=>{
            console.log("Action Added",data);
            this.newActionId = data.RESULT.RESPONSE.ActionId;
            this.model.unset('actions', {silent: true}); //Force to reload from server
            this.render();         
            $("button[name=addAction]").prop('disabled', false);
        }).catch((err)=> {            
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Creating New Action. ' + errMsg);
        });
    }

    deleteAction(){

        const selectedRow = $(this.tableId).jqGrid('getGridParam','selrow');
        const connectionId = this.model.get("connectionId");

        if (selectedRow) {
            const rowData = $(this.tableId).jqGrid('getRowData', selectedRow);
            let simpleModal = util.createDialogDeleteConfirmation("Delete Connection", `Are you sure you want to delete the action ${rowData.name}?`);
            simpleModal.render().then((result) => {
                if (result === 'Ok') {
                    RestService.deleteAction(selectedRow, connectionId).then(response => {
                        console.log("Action deleted");
                        $(this.tableId).delRowData(selectedRow);
                        this.render();
                    }).catch(err => {
                        console.log('Error Deleting Action', err);
                        NotificationService.error('Error Deleting Action' + err.MESSAGE);
                    });
                }
            }).catch((err) => {
                console.log('Error In Delete Action Confirmation Message', err);
            });


        }
    }

    editAction(ev){

        const editCurrentAction = () => {
            const button = $(ev.currentTarget);
            const actionId = button.closest("tr")[0].id;
            const connectionId = this.model.get("connectionId");

            this.selectedConnection = connectionId + "-" + actionId;

            eventBus.trigger(constants.EV_REFRESH_ACTION_DETAILS, actionId, connectionId);
        };

        const applyChangesElement = $('input[name="applyChanges"]'),
            confirmationText = 'Are you sure you want to leave this page?<br /><br />All changes made to the current page will be lost.',
            subtitle = `Connection - ${this.connectionService.model.get('connectionDetails').Name}`;

        util.showConfirmationDashboardChangesModal(applyChangesElement, editCurrentAction, confirmationText, subtitle, ev, this);
    }

    afterSaveCell(rowid, cellName, value, iRow, iCol, self){        
        let rowData = $(self.tableId).jqGrid('getRowData', rowid);
        self.saveAction(rowid, rowData.name, rowData.active);
    }

    onCellSelect(rowid, iCol, cellcontent, e, self){

        self.checkUserPermission(rowid);
        if(iCol === 3){ //If it is the active checkbox
            let rowData = $(self.tableId).jqGrid('getRowData', rowid);
            self.saveAction(rowid, rowData.name, rowData.active);
        }
    }

    checkUserPermission(rowid){
        let rowData = $(this.tableId).jqGrid('getRowData', rowid);
        const currentUserId = listService.accountSettings.UserId;
        
        if(rowData.owner === currentUserId){
            $("button[name=removeAction]").prop('disabled', false);
        }
        else{
            $("button[name=removeAction]").prop('disabled', true);
        }
    }


    renderDashboardTable(){
        const isVectorDB = this.model.get('connectionType') === constants.VECTORDB_GROUP_TYPE;
        let actionListTableOptions = {
            id: "actionsList",
            title: "Actions",
            height: isVectorDB ? 200 : "auto",
            datatype: "local",
            cellEdit: true,
            colModel: this.model.get('actionsModel').colModel,
            colNames: this.model.get('actionsModel').colNames,
            multiselect: false,
            items: this.model.get("actions"),
            filter: {tag: "Action Name", columnId: "name"}
        }

        this.actionsTable = new DashboardTable({ model: new Model({ tableOptions: actionListTableOptions, currentView: this }), el: '#actionTable' });
        this.actionsTable.render();

        if(this.newActionId){
            $(this.tableId).setSelection(this.newActionId, false);
            this.checkUserPermission(this.newActionId);
        }

        $("#actionTableOperations").show();
    }


    getConnectionActions(){
        const connectionId = this.model.get("connectionId");
        let actions = [];
        const self = this;

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        if (!this.model.get('actions')){ //Avoid unnecessary calls to server
            RestService.getActionsByConnectionId(connectionId, constants.SETTINGS_CONNECTIONS_FORM_ID, constants.SETTINGS_CONNECTIONS_PURPOSE).then((data) => {
                _.each(data, (action) => {
                    if(action["@ActionId"]){
                        actions.push({"id": action["@ActionId"],"owner": action["@CreateUserId"], "name": action["@Name"], "active": action["@IsActive"]});
                    }
                });

                this.model.set("actions", actions);

                self.renderDashboardTable();

                spinner.stop();
            }).catch((error) => {
                spinner.stop();
                console.log(error);
                var msg = error || 'Unknown Error';
                NotificationService.error(msg);
            });
        }else{
            this.renderDashboardTable();
            spinner.stop();
        }

    }

    render() {
        
        this.$el.empty();
        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.getConnectionActions();

        this.delegateEvents();
        return this;
    }
}

export default ConnectionActionView;